// extracted by mini-css-extract-plugin
module.exports = {"parts_header":"PartsToolbar_parts_header__1X8Mf","parts_header_title":"PartsToolbar_parts_header_title__3iAWI"};